import styles from './Main.css';
import React from 'react';
import PropTypes from 'prop-types';

class Main extends React.Component {
  render() {
    return (
      <div className={styles.container} data-test-id="auth-pages">
        {this.props.children}
      </div>
    );
  }
}

Main.propTypes = {
  children: PropTypes.object.isRequired
};

export default Main;
